import { useEffect, useState } from "react";
import useForm from "../../../../hooks/useForm";
import Modal from "../../../elements/Modal";
import Button from "../../../form/Button";
import Form from "../../../form/Form";
import Input from "../../../form/Input";
import { folderAddEdit } from "../../../../services/mediaService";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";

const ManageFolder = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  const validation = {
    name: { required: true, message: "Folder name is required" },
  };
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
  });
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const folderData = searchParams.get("folderData");

  const onSubmit = async () => {
    setLoading(true);
    const payload = {
      name: values?.name,
      ...(data?._id && { id: data?._id }),
      ...(folderData && { key: folderData }),
    };

    try {
      const result = await folderAddEdit(payload);
      if (result?.status === 200 || result?.status === 201) {
        toast.success(result.message || "Folder saved successfully");
        getResponse(result);
      } else {
        toast.error(result.message || "Failed to save folder");
      }
    } catch (error) {
      toast.error(error.message || "Failed to save folder");
    }
    resetField();
    setLoading(false);
  };

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({ name: data?.name });
    }
  }, [data]);

  return (
    <>
      <Modal
        isOpen={open}
        setIsOpen={() => {
          close();
          resetField();
        }}
        title={"Add Folder"}
        size="xl"
        modaltitleClasses={"!text-slate-200 text-[15px]"}
        headerClass={""}
        titleIcon={"titleIcon"}
        subtitle={"Create a new folder to organize your files."}
      >
        <Form onSubmit={onSubmit} handleSubmit={handleSubmit} loading={loading}>
          <div className="h-full overflow-y-auto">
            <div className="grid grid-cols-1 gap-3">
              <Input
                label={"Folder Name"}
                inputType={"name"}
                inputPlaceholder="Enter folder name"
                inputName={"name"}
                value={values?.name}
                onChange={handleChange}
                {...formValidate(errors, "name")}
              />
            </div>
          </div>
          <div className="pt-3 pb-2 flex justify-end">
            <Button
              buttonType="submit"
              buttonClasses={"min-w-36"}
              buttonLabel={data?._id ? "Update" : "Save"}
              {...(loading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ManageFolder;
